import { cartApiUrl } from '../config/serviceUrl';
import AuthHelper from './authHelper';
import { Vendor, vendors } from '../config/vendor';
import { Voucher } from '../types/voucher';

export const checkoutHandler = async (voucher: Voucher, vendor: string): Promise<any> => {
    const vendorProperties = vendors[vendor];
    try {
        const cartObject = await createCart(vendorProperties);
        if (cartObject.error) {
            return cartObject;
        }
        const shopProductObject = await addVoucherToCart(cartObject.ID, voucher, vendorProperties);
        if (shopProductObject.error) {
            return shopProductObject;
        }
        const shopUrlLocation = await getRedirectUrl(shopProductObject.CartID);
        if (shopUrlLocation.error) {
            return shopUrlLocation;
        }
        window.location.href = shopUrlLocation.ShopURL;
    } catch (e) {
        console.log(e);
        return { error: true };
    }
};

const createCart = async (vendor: Vendor) => {
    const baseBody = {
        Channel: vendor.channel,
        Locale: vendor.locale,
    };

    const authHelper = new AuthHelper();
    const userId = authHelper.getUserIdentifier();
    const accountId = {
        AccountId: userId,
    };

    const body = Object.assign(baseBody, accountId);

    try {
        const response = await fetch(cartApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await handleResponse(response);
    } catch (e) {
        console.log(`${e} - cannot retrieve cartId`);
        return { error: true };
    }
};

const addVoucherToCart = async (cartId: string, voucher: Voucher, vendor: Vendor) => {
    try {
        const response = await fetch(`${cartApiUrl}/${cartId}/Items`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                Discountable: false,
                CartID: cartId,
                ChannelName: vendor.channel,
                Amount: 1,
                Configuration: {
                    Article: {
                        ID: 'PAP_050',
                    },
                    ChosenExtras: {
                        ChosenVoucherDiscount: {
                            Option: {
                                Title: null,
                                ID: voucher.voucherId,
                            },
                        },
                    },
                },
                Template: {
                    PredesignedProductID: voucher.preDesignedProductId,
                },
                EditorTypeID: 'CMS',
                ProductTitle: voucher.checkoutLabel,
            }),
        });
        return await handleResponse(response);
    } catch (e) {
        console.log(`${e} - cannot add voucher`);
        return { error: true };
    }
};

const getRedirectUrl = async (cartId: string) => {
    try {
        const response = await fetch(`${cartApiUrl}/${cartId}/ShopURL`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return await handleResponse(response);
    } catch (e) {
        console.log(`${e} - cannot retrieve shopURL`);
        return { error: true };
    }
};

const handleResponse = async (response: Response): Promise<any> => {
    if (response.ok) {
        return await response.json();
    }
    throw new Error(response.statusText);
};
